import { useRef, useEffect, EffectCallback, DependencyList } from 'react';

const useEffectAfterMount = (effect: EffectCallback, deps?: DependencyList) => {
  const isMountRef = useRef(true);

  useEffect(() => {
    if (isMountRef.current) {
      isMountRef.current = false;
    } else {
      const cleanup = effect();

      if (cleanup) {
        return cleanup;
      }
    }
  }, deps);
};

export default useEffectAfterMount;
